import React from 'react';
import "./SpinnerDiv.scss";

const SpinnerDiv = (props) =>
{
   const elems =  [1,2,3,4,5,6,7,8,9,10,11,12] ;

	return (
		<div className={'sk-fading-circle ' + props.size}>
			{elems.map((i) =>
			{
				return (
					<div key={'circ' + i} className={'sk-circle sk-circle-' + i}/>
				);
			})}
		</div>
	)
}

export default SpinnerDiv ;